/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';

import {EmailBanner} from 'src/components/editorial/EmailBanner';
import {ChiefLogo} from 'src/svgs/chiefLogo';
import styled from 'styled-components/macro';

import {BannerContentQuote} from './BannerContentQuote';
import {BenefitCta} from './BenefitCta';
import {NextUpChiefHighlights} from './NextUpChiefHighlights';
import {NextUpFeatured} from './NextUpFeatured';
import {NextUpTrending} from './NextUpTrending';
import {EditorialQuote} from './Quote';

const Content = styled(NextUpChiefHighlights)``;

type SupportingContentProps = any;

export const SupportingContent: React.FC<SupportingContentProps> = (props: SupportingContentProps) => {
  return (
    <>
      {props.supportingContent?.map((block: any) => {
        const component = () => {
          switch (block._type) {
            case 'nextUpFeatured':
              return (
                <NextUpFeatured
                  heading={block.heading}
                  cta={block.cta}
                  article={block.article}
                  key={block._ref}
                  defaultArticle={false}
                />
              );
            case 'benefitCtaReference':
              return <BenefitCta block={block.benefitCtaReference} />;
            case 'nextUpChiefHighlights':
              return (
                <div className="px-gutter module-spacing relative bg-green-dark">
                  <div className="wrapper-default grid grid-cols-4 md:grid-cols-12 gap-8 md:text-white">
                    <div className="col-span-full lg:col-span-8 lg:col-start-2 mt-1 md:mt-7 prose prose-bg-green">
                      <div className="mb-4 lg:mb-12">
                        <ChiefLogo classes={'h-[18px] lg:w-25 lg:h-5 fill-ivory'} />
                      </div>
                      <Content blocks={block.chiefHighlightsContent} />
                    </div>
                  </div>
                </div>
              );
            case 'articleFooterBannerContentQuote':
              return <BannerContentQuote block={block} />;
            case 'nextUpTrending':
              return <NextUpTrending block={block} />;
            case 'emailSignUp':
              return <EmailBanner id="newsletter-form" {...block} fullWidth={true} />;
            case 'quote':
              return <EditorialQuote {...block} />;
            default:
              return null;
          }
        };
        return (
          <div className="w-full" key={block._key}>
            {component()}
          </div>
        );
      })}
    </>
  );
};
